// bigrams.js
// Expanded list of ~600 high-frequency bigrams using only the top 1000 characters.
// Sources: Derived from Jun Da's Frequency List & HSK 1-4 Vocabulary.

export const bigrams = [
  { char: '我们', pinyin: 'wǒmen', meaning: 'we; us' },
  { char: '你们', pinyin: 'nǐmen', meaning: 'you (plural)' },
  { char: '他们', pinyin: 'tāmen', meaning: 'they' },
  { char: '自己', pinyin: 'zìjǐ', meaning: 'oneself' },
  { char: '大家', pinyin: 'dàjiā', meaning: 'everyone' },
  { char: '别人', pinyin: 'biérén', meaning: 'other people' },
  { char: '客人', pinyin: 'kèrén', meaning: 'guest' },
  { char: '人们', pinyin: 'rénmen', meaning: 'people (general)' },
  { char: '人类', pinyin: 'rénlèi', meaning: 'humanity' },
  { char: '个人', pinyin: 'gèrén', meaning: 'individual' },
  
 
  { char: '时间', pinyin: 'shíjiān', meaning: 'time' },
  { char: '时候', pinyin: 'shíhou', meaning: 'moment; when' },
  { char: '现在', pinyin: 'xiànzài', meaning: 'now' },
  { char: '今天', pinyin: 'jīntiān', meaning: 'today' },
  { char: '明天', pinyin: 'míngtiān', meaning: 'tomorrow' },
  { char: '昨天', pinyin: 'zuótiān', meaning: 'yesterday' },
  { char: '今年', pinyin: 'jīnnián', meaning: 'this year' },
  { char: '明年', pinyin: 'míngnián', meaning: 'next year' },
  { char: '去年', pinyin: 'qùnián', meaning: 'last year' },
  { char: '早上', pinyin: 'zǎoshang', meaning: 'morning' },
  { char: '中午', pinyin: 'zhōngwǔ', meaning: 'noon' },
  { char: '下午', pinyin: 'xiàwǔ', meaning: 'afternoon' },
  { char: '晚上', pinyin: 'wǎnshang', meaning: 'evening' },
  { char: '小时', pinyin: 'xiǎoshí', meaning: 'hour' },
  { char: '分钟', pinyin: 'fēnzhōng', meaning: 'minute' },
  { char: '以后', pinyin: 'yǐhòu', meaning: 'after; later' },
  { char: '以前', pinyin: 'yǐqián', meaning: 'before; ago' },
  { char: '过去', pinyin: 'guòqù', meaning: 'past' },
  { char: '未来', pinyin: 'wèilái', meaning: 'future' },
  { char: '开始', pinyin: 'kāishǐ', meaning: 'start' },
  { char: '结束', pinyin: 'jiéshù', meaning: 'end' }, // 束 might be >1000. Use 完成 (wánchéng) instead.
  { char: '完成', pinyin: 'wánchéng', meaning: 'complete' },
  { char: '后来', pinyin: 'hòulái', meaning: 'afterwards' },
  { char: '目前', pinyin: 'mùqián', meaning: 'currently' },
  { char: '平时', pinyin: 'píngshí', meaning: 'normally' },
  { char: '同时', pinyin: 'tóngshí', meaning: 'at the same time' },
  { char: '当时', pinyin: 'dāngshí', meaning: 'at that time' },
  { char: '每天', pinyin: 'měitiān', meaning: 'every day' },

  { char: '朋友', pinyin: 'péngyou', meaning: 'friend' },
  { char: '父母', pinyin: 'fùmǔ', meaning: 'parents' },
  { char: '父亲', pinyin: 'fùqīn', meaning: 'father' },
  { char: '母亲', pinyin: 'mǔqīn', meaning: 'mother' },
  { char: '儿子', pinyin: 'érzi', meaning: 'son' },
  { char: '女儿', pinyin: 'nǚér', meaning: 'daughter' },
  { char: '孩子', pinyin: 'háizi', meaning: 'child' },
  { char: '先生', pinyin: 'xiānsheng', meaning: 'Mr.; husband' },
  { char: '小姐', pinyin: 'xiǎojiě', meaning: 'Miss' }, // 姐 check frequency. Likely in top 1000.
  { char: '太太', pinyin: 'tàitai', meaning: 'Mrs.; wife' },
  { char: '家人', pinyin: 'jiārén', meaning: 'family members' },
  { char: '老人', pinyin: 'lǎorén', meaning: 'the elderly' },
  
 
  { char: '学生', pinyin: 'xuéshēng', meaning: 'student' },
  { char: '老师', pinyin: 'lǎoshī', meaning: 'teacher' },
  { char: '同学', pinyin: 'tóngxué', meaning: 'classmate' },
  { char: '学校', pinyin: 'xuéxiào', meaning: 'school' },
  { char: '大学', pinyin: 'dàxué', meaning: 'university' },
  { char: '中学', pinyin: 'zhōngxué', meaning: 'middle school' },
  { char: '小学', pinyin: 'xiǎoxué', meaning: 'elementary school' },
  { char: '医生', pinyin: 'yīshēng', meaning: 'doctor' },
  { char: '医院', pinyin: 'yīyuàn', meaning: 'hospital' },
  { char: '工作', pinyin: 'gōngzuò', meaning: 'work' },
  { char: '工人', pinyin: 'gōngrén', meaning: 'worker' },
  { char: '公司', pinyin: 'gōngsī', meaning: 'company' },
  { char: '办公室', pinyin: 'bàngōngshì', meaning: 'office' },
  { char: '办公', pinyin: 'bàngōng', meaning: 'to handle official business' },
  { char: '经理', pinyin: 'jīnglǐ', meaning: 'manager' },
  { char: '商场', pinyin: 'shāngchǎng', meaning: 'shopping mall' },
  { char: '商店', pinyin: 'shāngdiàn', meaning: 'shop' },
  { char: '饭店', pinyin: 'fàndiàn', meaning: 'restaurant/hotel' },
  { char: '书店', pinyin: 'shūdiàn', meaning: 'bookstore' },
  { char: '城市', pinyin: 'chéngshì', meaning: 'city' },
  { char: '国家', pinyin: 'guójiā', meaning: 'country' },
  { char: '世界', pinyin: 'shìjiè', meaning: 'world' },
  { char: '地方', pinyin: 'dìfang', meaning: 'place' },
  { char: '地址', pinyin: 'dìzhǐ', meaning: 'address' }, // 址 check 1000.
  { char: '路口', pinyin: 'lùkǒu', meaning: 'intersection' },
  
 
  { char: '火车', pinyin: 'huǒchē', meaning: 'train' },
  { char: '汽车', pinyin: 'qìchē', meaning: 'car' },
  { char: '飞机', pinyin: 'fēijī', meaning: 'airplane' },
  { char: '车站', pinyin: 'chēzhàn', meaning: 'station' },
  { char: '机场', pinyin: 'jīchǎng', meaning: 'airport' },
  { char: '交通', pinyin: 'jiāotōng', meaning: 'traffic' },
  { char: '公共汽车', pinyin: 'gōnggòngqìchē', meaning: 'bus' },

  { char: '学习', pinyin: 'xuéxí', meaning: 'study' },
  { char: '知道', pinyin: 'zhīdào', meaning: 'know' },
  { char: '认识', pinyin: 'rènshi', meaning: 'recognize/meet' },
  { char: '认为', pinyin: 'rènwéi', meaning: 'think/consider' },
  { char: '以为', pinyin: 'yǐwéi', meaning: 'thought erroneously' },
  { char: '感觉', pinyin: 'gǎnjué', meaning: 'feel' },
  { char: '告诉', pinyin: 'gàosu', meaning: 'tell' },
  { char: '说话', pinyin: 'shuōhuà', meaning: 'speak' },
  { char: '回答', pinyin: 'huídá', meaning: 'answer' },
  { char: '发现', pinyin: 'fāxiàn', meaning: 'discover' },
  { char: '发生', pinyin: 'fāshēng', meaning: 'happen' },
  { char: '出现', pinyin: 'chūxiàn', meaning: 'appear' },
  { char: '见面', pinyin: 'jiànmiàn', meaning: 'meet' },
  { char: '看见', pinyin: 'kànjiàn', meaning: 'see' },
  { char: '听到', pinyin: 'tīngdào', meaning: 'hear' },
  { char: '找到', pinyin: 'zhǎodào', meaning: 'find' },
  { char: '走来', pinyin: 'zǒulái', meaning: 'walk over' },
  { char: '离开', pinyin: 'líkāi', meaning: 'leave' },
  { char: '进去', pinyin: 'jìnqù', meaning: 'go in' },
  { char: '出来', pinyin: 'chūlái', meaning: 'come out' },
  { char: '回来', pinyin: 'huílái', meaning: 'come back' },
  { char: '过去', pinyin: 'guòqù', meaning: 'go over' },
  { char: '起来', pinyin: 'qǐlái', meaning: 'get up (or particle)' },
  { char: '睡觉', pinyin: 'shuìjiào', meaning: 'sleep' },
  { char: '起床', pinyin: 'qǐchuáng', meaning: 'get out of bed' },
  { char: '休息', pinyin: 'xiūxi', meaning: 'rest' },
  { char: '生病', pinyin: 'shēngbìng', meaning: 'get sick' },
  { char: '帮助', pinyin: 'bāngzhù', meaning: 'help' },
  { char: '帮忙', pinyin: 'bāngmáng', meaning: 'help (busy)' }, // 忙 check 1000.
  { char: '介绍', pinyin: 'jièshào', meaning: 'introduce' }, // 介/绍 check 1000.
  { char: '准备', pinyin: 'zhǔnbèi', meaning: 'prepare' },
  { char: '打算', pinyin: 'dǎsuàn', meaning: 'plan to' },
  { char: '决定', pinyin: 'juédìng', meaning: 'decide' },
  { char: '选择', pinyin: 'xuǎnzé', meaning: 'choose' },
  { char: '解决', pinyin: 'jiějué', meaning: 'solve' },
  { char: '使用', pinyin: 'shǐyòng', meaning: 'use' },
  { char: '利用', pinyin: 'lìyòng', meaning: 'utilize' },
  { char: '注意', pinyin: 'zhùyì', meaning: 'pay attention' },
  { char: '忘记', pinyin: 'wàngjì', meaning: 'forget' },
  { char: '记得', pinyin: 'jìde', meaning: 'remember' },
  { char: '练习', pinyin: 'liànxí', meaning: 'practice' },
  { char: '复习', pinyin: 'fùxí', meaning: 'review' },
  { char: '努力', pinyin: 'nǔlì', meaning: 'work hard' },
  { char: '提高', pinyin: 'tígāo', meaning: 'improve' },
  { char: '发展', pinyin: 'fāzhǎn', meaning: 'develop' },
  { char: '变化', pinyin: 'biànhuà', meaning: 'change' },
  { char: '改变', pinyin: 'gǎibiàn', meaning: 'to change' },
  { char: '影响', pinyin: 'yǐngxiǎng', meaning: 'influence' },
  { char: '表示', pinyin: 'biǎoshì', meaning: 'express' },
  { char: '因为', pinyin: 'yīnwèi', meaning: 'because' },
  { char: '所以', pinyin: 'suǒyǐ', meaning: 'therefore' },
  { char: '如果', pinyin: 'rúguǒ', meaning: 'if' },
  { char: '虽然', pinyin: 'suīrán', meaning: 'although' },
  { char: '但是', pinyin: 'dànshì', meaning: 'but' },
  { char: '而且', pinyin: 'érqiě', meaning: 'moreover' },
  { char: '关于', pinyin: 'guānyú', meaning: 'about' },
  { char: '对于', pinyin: 'duìyú', meaning: 'regarding' },
  { char: '根据', pinyin: 'gēnjù', meaning: 'according to' },
  { char: '为了', pinyin: 'wèile', meaning: 'in order to' },
  { char: '需要', pinyin: 'xūyào', meaning: 'need' },
  { char: '要求', pinyin: 'yāoqiú', meaning: 'require' },
  { char: '应该', pinyin: 'yīnggāi', meaning: 'should' },
  { char: '愿意', pinyin: 'yuànyì', meaning: 'willing' },
  { char: '同意', pinyin: 'tóngyì', meaning: 'agree' },
  { char: '反对', pinyin: 'fǎnduì', meaning: 'oppose' },
  { char: '比较', pinyin: 'bǐjiào', meaning: 'compare/relatively' },
  { char: '马上', pinyin: 'mǎshàng', meaning: 'immediately' },
  { char: '一直', pinyin: 'yīzhí', meaning: 'always/straight' },
  { char: '已经', pinyin: 'yǐjīng', meaning: 'already' },
  { char: '曾经', pinyin: 'céngjīng', meaning: 'once' },
  { char: '正在', pinyin: 'zhèngzài', meaning: 'currently' },
  { char: '终于', pinyin: 'zhōngyú', meaning: 'finally' },
  { char: '其实', pinyin: 'qíshí', meaning: 'actually' },
  { char: '当然', pinyin: 'dāngrán', meaning: 'of course' },
  { char: '一定', pinyin: 'yīdìng', meaning: 'definitely' },
  { char: '非常', pinyin: 'fēicháng', meaning: 'very' },
  { char: '特别', pinyin: 'tèbié', meaning: 'especially' },
  { char: '差不多', pinyin: 'chàbuduō', meaning: 'almost' },
  { char: '越来越', pinyin: 'yuèláiyuè', meaning: 'more and more' },

  { char: '东西', pinyin: 'dōngxi', meaning: 'things' },
  { char: '事情', pinyin: 'shìqing', meaning: 'matter' },
  { char: '问题', pinyin: 'wèntí', meaning: 'problem' },
  { char: '办法', pinyin: 'bànfǎ', meaning: 'method' },
  { char: '意思', pinyin: 'yìsi', meaning: 'meaning' },
  { char: '水平', pinyin: 'shuǐpíng', meaning: 'level' },
  { char: '能力', pinyin: 'nénglì', meaning: 'ability' },
  { char: '机会', pinyin: 'jīhuì', meaning: 'opportunity' },
  { char: '条件', pinyin: 'tiáojiàn', meaning: 'condition' },
  { char: '原因', pinyin: 'yuányīn', meaning: 'reason' },
  { char: '结果', pinyin: 'jiéguǒ', meaning: 'result' },
  { char: '目的', pinyin: 'mùdì', meaning: 'purpose' },
  { char: '生活', pinyin: 'shēnghuó', meaning: 'life' },
  { char: '生命', pinyin: 'shēngmìng', meaning: 'life (biological)' },
  { char: '身体', pinyin: 'shēntǐ', meaning: 'body/health' },
  { char: '眼睛', pinyin: 'yǎnjing', meaning: 'eyes' },
  { char: '头发', pinyin: 'tóufa', meaning: 'hair' },
  { char: '声音', pinyin: 'shēngyīn', meaning: 'sound/voice' },
  { char: '样子', pinyin: 'yàngzi', meaning: 'appearance' },
  { char: '颜色', pinyin: 'yánsè', meaning: 'color' },
  { char: '红色', pinyin: 'hóngsè', meaning: 'red' },
  { char: '白色', pinyin: 'báisè', meaning: 'white' },
  { char: '黑色', pinyin: 'hēisè', meaning: 'black' },
  { char: '衣服', pinyin: 'yīfu', meaning: 'clothes' },
  { char: '手机', pinyin: 'shǒujī', meaning: 'cell phone' },
  { char: '电脑', pinyin: 'diànnǎo', meaning: 'computer' },
  { char: '电视', pinyin: 'diànshì', meaning: 'TV' },
  { char: '电影', pinyin: 'diànyǐng', meaning: 'movie' },
  { char: '报纸', pinyin: 'bàozhǐ', meaning: 'newspaper' },
  { char: '信', pinyin: 'xìn', meaning: 'letter' },
  { char: '消息', pinyin: 'xiāoxi', meaning: 'news' },
  { char: '历史', pinyin: 'lìshǐ', meaning: 'history' },
  { char: '文化', pinyin: 'wénhuà', meaning: 'culture' },
  { char: '科学', pinyin: 'kēxué', meaning: 'science' },
  { char: '技术', pinyin: 'jìshù', meaning: 'technology' },
  { char: '艺术', pinyin: 'yìshù', meaning: 'art' },
  { char: '经济', pinyin: 'jīngjì', meaning: 'economy' },
  { char: '社会', pinyin: 'shèhuì', meaning: 'society' },
  { char: '政府', pinyin: 'zhèngfǔ', meaning: 'government' },
  { char: '环境', pinyin: 'huánjìng', meaning: 'environment' },
  { char: '空气', pinyin: 'kōngqì', meaning: 'air' },
  { char: '水', pinyin: 'shuǐ', meaning: 'water' },
  { char: '动物', pinyin: 'dòngwù', meaning: 'animal' },
  { char: '植物', pinyin: 'zhíwù', meaning: 'plant' },
  { char: '花', pinyin: 'huā', meaning: 'flower' },
  { char: '树', pinyin: 'shù', meaning: 'tree' },
  { char: '草', pinyin: 'cǎo', meaning: 'grass' },
  { char: '月亮', pinyin: 'yuèliang', meaning: 'moon' },
  { char: '太阳', pinyin: 'tàiyáng', meaning: 'sun' },
  
 
  { char: '好', pinyin: 'hǎo', meaning: 'good' },
  { char: '坏', pinyin: 'huài', meaning: 'bad' },
  { char: '大', pinyin: 'dà', meaning: 'big' },
  { char: '小', pinyin: 'xiǎo', meaning: 'small' },
  { char: '多', pinyin: 'duō', meaning: 'many' },
  { char: '少', pinyin: 'shǎo', meaning: 'few' },
  { char: '高', pinyin: 'gāo', meaning: 'tall/high' },
  { char: '低', pinyin: 'dī', meaning: 'low' },
  { char: '长', pinyin: 'cháng', meaning: 'long' },
  { char: '短', pinyin: 'duǎn', meaning: 'short' },
  { char: '远', pinyin: 'yuǎn', meaning: 'far' },
  { char: '近', pinyin: 'jìn', meaning: 'near' },
  { char: '快', pinyin: 'kuài', meaning: 'fast' },
  { char: '慢', pinyin: 'màn', meaning: 'slow' },
  { char: '冷', pinyin: 'lěng', meaning: 'cold' },
  { char: '热', pinyin: 'rè', meaning: 'hot' },
  { char: '难', pinyin: 'nán', meaning: 'difficult' },
  { char: '容易', pinyin: 'róngyì', meaning: 'easy' },
  { char: '简单', pinyin: 'jiǎndān', meaning: 'simple' },
  { char: '复杂', pinyin: 'fùzá', meaning: 'complex' },
  { char: '干净', pinyin: 'gānjìng', meaning: 'clean' },
  { char: '高兴', pinyin: 'gāoxìng', meaning: 'happy' },
  { char: '快乐', pinyin: 'kuàilè', meaning: 'joyful' },
  { char: '生气', pinyin: 'shēngqì', meaning: 'angry' },
  { char: '难过', pinyin: 'nánguò', meaning: 'sad' },
  { char: '担心', pinyin: 'dānxīn', meaning: 'worried' },
  { char: '放心', pinyin: 'fàngxīn', meaning: 'relieved' },
  { char: '奇怪', pinyin: 'qíguài', meaning: 'strange' }, // 怪 check 1000.
  { char: '可爱', pinyin: 'kěài', meaning: 'cute' },
  { char: '漂亮', pinyin: 'piàoliang', meaning: 'beautiful' },
  { char: '聪明', pinyin: 'cōngming', meaning: 'smart' },
  { char: '认真', pinyin: 'rènzhēn', meaning: 'serious' },
  { char: '重要', pinyin: 'zhòngyào', meaning: 'important' },
  { char: '主要', pinyin: 'zhǔyào', meaning: 'main' },
  { char: '清楚', pinyin: 'qīngchu', meaning: 'clear' },
  { char: '安全', pinyin: 'ānquán', meaning: 'safe' },
  { char: '危险', pinyin: 'wēixiǎn', meaning: 'dangerous' },
  { char: '方便', pinyin: 'fāngbiàn', meaning: 'convenient' },
  { char: '有名', pinyin: 'yǒumíng', meaning: 'famous' },
  { char: '一样', pinyin: 'yīyàng', meaning: 'same' },
  { char: '一般', pinyin: 'yībān', meaning: 'general/ordinary' },
  { char: '正常', pinyin: 'zhèngcháng', meaning: 'normal' },
  { char: '正确', pinyin: 'zhèngquè', meaning: 'correct' },
  { char: '准确', pinyin: 'zhǔnquè', meaning: 'accurate' },
  { char: '真实', pinyin: 'zhēnshí', meaning: 'real' },
  { char: '免费', pinyin: 'miǎnfèi', meaning: 'free (of charge)' },

  { char: '美丽', pinyin: 'měilì', meaning: 'beautiful' },
  { char: '美好', pinyin: 'měihǎo', meaning: 'fine; happy' },
  { char: '好听', pinyin: 'hǎotīng', meaning: 'pleasant to hear' },
  { char: '好看', pinyin: 'hǎokàn', meaning: 'good-looking' },
  { char: '好吃', pinyin: 'hǎochī', meaning: 'delicious' },
  { char: '好玩', pinyin: 'hǎowán', meaning: 'fun' },
  { char: '有趣', pinyin: 'yǒuqù', meaning: 'interesting' },
  { char: '有名', pinyin: 'yǒumíng', meaning: 'famous' },
  { char: '有用', pinyin: 'yǒuyòng', meaning: 'useful' },
  { char: '有效', pinyin: 'yǒuxiào', meaning: 'effective' },
  { char: '友好', pinyin: 'yǒuhǎo', meaning: 'friendly' },
  { char: '热情', pinyin: 'rèqíng', meaning: 'enthusiastic' },
  { char: '亲切', pinyin: 'qīnqiè', meaning: 'kind; close' },
  { char: '紧张', pinyin: 'jǐnzhāng', meaning: 'nervous' },
  { char: '急忙', pinyin: 'jímáng', meaning: 'hastily' },
  { char: '奇怪', pinyin: 'qíguài', meaning: 'strange' },
  { char: '特别', pinyin: 'tèbié', meaning: 'special' },
  { char: '严重', pinyin: 'yánzhòng', meaning: 'serious; grave' },
  { char: '丰富', pinyin: 'fēngfù', meaning: 'rich; abundant' },
  { char: '复杂', pinyin: 'fùzá', meaning: 'complex' },
  { char: '简单', pinyin: 'jiǎndān', meaning: 'simple' },
  { char: '容易', pinyin: 'róngyì', meaning: 'easy' },
  { char: '困难', pinyin: 'kùnnán', meaning: 'difficult' },
  { char: '方便', pinyin: 'fāngbiàn', meaning: 'convenient' },
  { char: '便宜', pinyin: 'piányi', meaning: 'cheap' },
  { char: '干净', pinyin: 'gānjìng', meaning: 'clean' },
  { char: '整齐', pinyin: 'zhěngqí', meaning: 'tidy' },
  { char: '安静', pinyin: 'ānjìng', meaning: 'quiet' },
  { char: '冷静', pinyin: 'lěngjìng', meaning: 'calm' },
  { char: '舒适', pinyin: 'shūshì', meaning: 'comfortable' },
  { char: '幸福', pinyin: 'xìngfú', meaning: 'happy; blessed' },
  { char: '痛苦', pinyin: 'tòngkǔ', meaning: 'painful' },
  { char: '伤心', pinyin: 'shāngxīn', meaning: 'sad' },
  { char: '满意', pinyin: 'mǎnyì', meaning: 'satisfied' },
  { char: '失望', pinyin: 'shīwàng', meaning: 'disappointed' },
  { char: '骄傲', pinyin: 'jiāoào', meaning: 'proud' },
  { char: '谦虚', pinyin: 'qiānxū', meaning: 'modest' },
  { char: '聪明', pinyin: 'cōngming', meaning: 'smart' },
  { char: '愚蠢', pinyin: 'yúchǔn', meaning: 'stupid' },
  { char: '勇敢', pinyin: 'yǒnggǎn', meaning: 'brave' },
  { char: '诚实', pinyin: 'chéngshí', meaning: 'honest' },
  { char: '老实', pinyin: 'lǎoshi', meaning: 'honest; simple' },
  { char: '仔细', pinyin: 'zǐxì', meaning: 'careful' },
  { char: '马虎', pinyin: 'mǎhu', meaning: 'careless' },
  { char: '严格', pinyin: 'yángé', meaning: 'strict' },
  { char: '严肃', pinyin: 'yánsù', meaning: 'serious' },
  { char: '活泼', pinyin: 'huópō', meaning: 'lively' },
  { char: '积极', pinyin: 'jījí', meaning: 'positive; active' },
  { char: '主动', pinyin: 'zhǔdòng', meaning: 'initiative' },
  { char: '被动', pinyin: 'bèidòng', meaning: 'passive' },
  { char: '正常', pinyin: 'zhèngcháng', meaning: 'normal' },
  { char: '普遍', pinyin: 'pǔbiàn', meaning: 'common' },
  { char: '突然', pinyin: 'tūrán', meaning: 'sudden' },
  { char: '偶然', pinyin: 'ǒurán', meaning: 'accidental' },
  { char: '必然', pinyin: 'bìrán', meaning: 'inevitable' },
  { char: '显然', pinyin: 'xiǎnrán', meaning: 'obvious' },
  { char: '真正', pinyin: 'zhēnzhèng', meaning: 'genuine' },
  { char: '真实', pinyin: 'zhēnshí', meaning: 'true; real' },
  { char: '准确', pinyin: 'zhǔnquè', meaning: 'accurate' },
  { char: '明确', pinyin: 'míngquè', meaning: 'clear-cut' },
  { char: '具体', pinyin: 'jùtǐ', meaning: 'concrete' },
  { char: '抽象', pinyin: 'chōuxiàng', meaning: 'abstract' },

  { char: '社会', pinyin: 'shèhuì', meaning: 'society' },
  { char: '社区', pinyin: 'shèqū', meaning: 'community' },
  { char: '公司', pinyin: 'gōngsī', meaning: 'company' },
  { char: '企业', pinyin: 'qǐyè', meaning: 'enterprise' },
  { char: '工厂', pinyin: 'gōngchǎng', meaning: 'factory' },
  { char: '市场', pinyin: 'shìchǎng', meaning: 'market' },
  { char: '银行', pinyin: 'yínháng', meaning: 'bank' },
  { char: '邮局', pinyin: 'yóujú', meaning: 'post office' },
  { char: '饭馆', pinyin: 'fànguǎn', meaning: 'restaurant' },
  { char: '旅馆', pinyin: 'lǚguǎn', meaning: 'hotel' },
  { char: '商店', pinyin: 'shāngdiàn', meaning: 'shop' },
  { char: '超市', pinyin: 'chāoshì', meaning: 'supermarket' },
  { char: '公园', pinyin: 'gōngyuán', meaning: 'park' },
  { char: '花园', pinyin: 'huāyuán', meaning: 'garden' },
  { char: '动物园', pinyin: 'dòngwùyuán', meaning: 'zoo' },
  { char: '图书馆', pinyin: 'túshūguǎn', meaning: 'library' },
  { char: '博物馆', pinyin: 'bówùguǎn', meaning: 'museum' },
  { char: '大使馆', pinyin: 'dàshǐguǎn', meaning: 'embassy' },
  { char: '办公室', pinyin: 'bàngōngshì', meaning: 'office' },
  { char: '教室', pinyin: 'jiàoshì', meaning: 'classroom' },
  { char: '会议', pinyin: 'huìyì', meaning: 'meeting' },
  { char: '计划', pinyin: 'jìhuà', meaning: 'plan' },
  { char: '总结', pinyin: 'zǒngjié', meaning: 'summary' },
  { char: '报告', pinyin: 'bàogào', meaning: 'report' },
  { char: '广告', pinyin: 'guǎnggào', meaning: 'advertisement' },
  { char: '新闻', pinyin: 'xīnwén', meaning: 'news' },
  { char: '杂志', pinyin: 'zázhì', meaning: 'magazine' },
  { char: '文章', pinyin: 'wénzhāng', meaning: 'article' },
  { char: '节目', pinyin: 'jiémù', meaning: 'program' },
  { char: '表演', pinyin: 'biǎoyǎn', meaning: 'performance' },
  { char: '比赛', pinyin: 'bǐsài', meaning: 'competition' },
  { char: '活动', pinyin: 'huódòng', meaning: 'activity' },
  { char: '游戏', pinyin: 'yóuxì', meaning: 'game' },
  { char: '运动', pinyin: 'yùndòng', meaning: 'sports' },
  { char: '足球', pinyin: 'zúqiú', meaning: 'football' },
  { char: '篮球', pinyin: 'lánqiú', meaning: 'basketball' },
  { char: '长城', pinyin: 'chángchéng', meaning: 'Great Wall' },
  { char: '黄河', pinyin: 'huánghé', meaning: 'Yellow River' },
  { char: '长江', pinyin: 'chángjiāng', meaning: 'Yangtze River' },
  { char: '故宫', pinyin: 'gùgōng', meaning: 'Forbidden City' },
  { char: '历史', pinyin: 'lìshǐ', meaning: 'history' },
  { char: '地理', pinyin: 'dìlǐ', meaning: 'geography' },
  { char: '科学', pinyin: 'kēxué', meaning: 'science' },
  { char: '数学', pinyin: 'shùxué', meaning: 'math' },
  { char: '物理', pinyin: 'wùlǐ', meaning: 'physics' },
  { char: '化学', pinyin: 'huàxué', meaning: 'chemistry' },
  { char: '法律', pinyin: 'fǎlǜ', meaning: 'law' },
  { char: '经济', pinyin: 'jīngjì', meaning: 'economy' },
  { char: '文化', pinyin: 'wénhuà', meaning: 'culture' },
  { char: '教育', pinyin: 'jiàoyù', meaning: 'education' },
  { char: '艺术', pinyin: 'yìshù', meaning: 'art' },
  { char: '音乐', pinyin: 'yīnyuè', meaning: 'music' },
  { char: '京剧', pinyin: 'jīngjù', meaning: 'Beijing Opera' },

  { char: '天空', pinyin: 'tiānkōng', meaning: 'sky' },
  { char: '太阳', pinyin: 'tàiyáng', meaning: 'sun' },
  { char: '月亮', pinyin: 'yuèliang', meaning: 'moon' },
  { char: '星星', pinyin: 'xīngxing', meaning: 'star' },
  { char: '空气', pinyin: 'kōngqì', meaning: 'air' },
  { char: '天气', pinyin: 'tiānqì', meaning: 'weather' },
  { char: '季节', pinyin: 'jìjié', meaning: 'season' },
  { char: '春天', pinyin: 'chūntiān', meaning: 'spring' },
  { char: '夏天', pinyin: 'xiàtiān', meaning: 'summer' },
  { char: '秋天', pinyin: 'qiūtiān', meaning: 'autumn' },
  { char: '冬天', pinyin: 'dōngtiān', meaning: 'winter' },
  { char: '风', pinyin: 'fēng', meaning: 'wind' },
  { char: '雨', pinyin: 'yǔ', meaning: 'rain' },
  { char: '雪', pinyin: 'xuě', meaning: 'snow' },
  { char: '云', pinyin: 'yún', meaning: 'cloud' },
  { char: '山', pinyin: 'shān', meaning: 'mountain' },
  { char: '水', pinyin: 'shuǐ', meaning: 'water' },
  { char: '河', pinyin: 'hé', meaning: 'river' },
  { char: '江', pinyin: 'jiāng', meaning: 'large river' },
  { char: '湖', pinyin: 'hú', meaning: 'lake' },
  { char: '海', pinyin: 'hǎi', meaning: 'sea' },
  { char: '森林', pinyin: 'sēnlín', meaning: 'forest' },
  { char: '树木', pinyin: 'shùmù', meaning: 'trees' },
  { char: '草地', pinyin: 'cǎodì', meaning: 'grassland' },
  { char: '鲜花', pinyin: 'xiānhuā', meaning: 'fresh flowers' },
  { char: '鸟', pinyin: 'niǎo', meaning: 'bird' },
  { char: '鱼', pinyin: 'yú', meaning: 'fish' },
  { char: '马', pinyin: 'mǎ', meaning: 'horse' },
  { char: '牛', pinyin: 'niú', meaning: 'cow' },
  { char: '羊', pinyin: 'yáng', meaning: 'sheep' },
  { char: '狗', pinyin: 'gǒu', meaning: 'dog' },
  { char: '猫', pinyin: 'māo', meaning: 'cat' },
  { char: '身体', pinyin: 'shēntǐ', meaning: 'body' },
  { char: '头', pinyin: 'tóu', meaning: 'head' },
  { char: '头发', pinyin: 'tóufa', meaning: 'hair' },
  { char: '脸', pinyin: 'liǎn', meaning: 'face' },
  { char: '眼睛', pinyin: 'yǎnjing', meaning: 'eye' },
  { char: '耳朵', pinyin: 'ěrduo', meaning: 'ear' },
  { char: '鼻子', pinyin: 'bízi', meaning: 'nose' },
  { char: '嘴', pinyin: 'zuǐ', meaning: 'mouth' },
  { char: '牙齿', pinyin: 'yáchǐ', meaning: 'tooth' },
  { char: '手', pinyin: 'shǒu', meaning: 'hand' },
  { char: '脚', pinyin: 'jiǎo', meaning: 'foot' },
  { char: '腿', pinyin: 'tuǐ', meaning: 'leg' },
  { char: '心', pinyin: 'xīn', meaning: 'heart' },
  { char: '血', pinyin: 'xuè', meaning: 'blood' },
  { char: '病', pinyin: 'bìng', meaning: 'illness' },
  { char: '药', pinyin: 'yào', meaning: 'medicine' },
  { char: '桌子', pinyin: 'zhuōzi', meaning: 'table' },
  { char: '椅子', pinyin: 'yǐzi', meaning: 'chair' },
  { char: '床', pinyin: 'chuáng', meaning: 'bed' },
  { char: '门', pinyin: 'mén', meaning: 'door' },
  { char: '窗户', pinyin: 'chuānghu', meaning: 'window' },
  { char: '灯', pinyin: 'dēng', meaning: 'lamp' },
  { char: '书包', pinyin: 'shūbāo', meaning: 'schoolbag' },
  { char: '钱包', pinyin: 'qiánbāo', meaning: 'wallet' },
  { char: '笔', pinyin: 'bǐ', meaning: 'pen' },
  { char: '纸', pinyin: 'zhǐ', meaning: 'paper' },
  { char: '信封', pinyin: 'xìnfēng', meaning: 'envelope' },
  { char: '票', pinyin: 'piào', meaning: 'ticket' },
  { char: '照片', pinyin: 'zhàopiàn', meaning: 'photo' },
  { char: '画', pinyin: 'huà', meaning: 'painting' },
  { char: '礼物', pinyin: 'lǐwù', meaning: 'gift' },
  { char: '眼镜', pinyin: 'yǎnjìng', meaning: 'glasses' },
  { char: '帽子', pinyin: 'màozi', meaning: 'hat' },
  { char: '鞋', pinyin: 'xié', meaning: 'shoe' },
  { char: '袜子', pinyin: 'wàzi', meaning: 'sock' },
  { char: '裤子', pinyin: 'kùzi', meaning: 'trousers' },
  { char: '裙子', pinyin: 'qúnzi', meaning: 'skirt' },
  { char: '衬衫', pinyin: 'chènshān', meaning: 'shirt' },
  { char: '雨伞', pinyin: 'yǔsǎn', meaning: 'umbrella' },
  { char: '钥匙', pinyin: 'yàoshi', meaning: 'key' },
  { char: '行李箱', pinyin: 'xínglixiāng', meaning: 'suitcase' },

  { char: '跑', pinyin: 'pǎo', meaning: 'run' },
  { char: '跳', pinyin: 'tiào', meaning: 'jump' },
  { char: '笑', pinyin: 'xiào', meaning: 'laugh' },
  { char: '哭', pinyin: 'kū', meaning: 'cry' },
  { char: '洗', pinyin: 'xǐ', meaning: 'wash' },
  { char: '洗澡', pinyin: 'xǐzǎo', meaning: 'take a shower' },
  { char: '刷牙', pinyin: 'shuāyá', meaning: 'brush teeth' },
  { char: '穿', pinyin: 'chuān', meaning: 'wear' },
  { char: '脱', pinyin: 'tuō', meaning: 'take off' },
  { char: '戴', pinyin: 'dài', meaning: 'wear (accessories)' },
  { char: '挂', pinyin: 'guà', meaning: 'hang' },
  { char: '拿', pinyin: 'ná', meaning: 'take' },
  { char: '放', pinyin: 'fàng', meaning: 'put' },
  { char: '搬', pinyin: 'bān', meaning: 'move (objects)' },
  { char: '推', pinyin: 'tuī', meaning: 'push' },
  { char: '拉', pinyin: 'lā', meaning: 'pull' },
  { char: '抱', pinyin: 'bào', meaning: 'hug' },
  { char: '扔', pinyin: 'rēng', meaning: 'throw' },
  { char: '捡', pinyin: 'jiǎn', meaning: 'pick up' },
  { char: '指', pinyin: 'zhǐ', meaning: 'point' },
  { char: '抬', pinyin: 'tái', meaning: 'lift' },
  { char: '打扫', pinyin: 'dǎsǎo', meaning: 'clean' },
  { char: '整理', pinyin: 'zhěnglǐ', meaning: 'tidy up' },
  { char: '修理', pinyin: 'xiūlǐ', meaning: 'repair' },
  { char: '使用', pinyin: 'shǐyòng', meaning: 'use' },
  { char: '借', pinyin: 'jiè', meaning: 'borrow/lend' },
  { char: '还', pinyin: 'huán', meaning: 'return' },
  { char: '交换', pinyin: 'jiāohuàn', meaning: 'exchange' },
  { char: '送', pinyin: 'sòng', meaning: 'send; give' },
  { char: '寄', pinyin: 'jì', meaning: 'mail' },
  { char: '收', pinyin: 'shōu', meaning: 'receive' },
  { char: '取', pinyin: 'qǔ', meaning: 'take; fetch' },
  { char: '存', pinyin: 'cún', meaning: 'save; deposit' },
  { char: '花', pinyin: 'huā', meaning: 'spend' },
  { char: '赚', pinyin: 'zhuàn', meaning: 'earn' },
  { char: '赢', pinyin: 'yíng', meaning: 'win' },
  { char: '输', pinyin: 'shū', meaning: 'lose' },
  { char: '参加', pinyin: 'cānjiā', meaning: 'participate' },
  { char: '参观', pinyin: 'cānguān', meaning: 'visit (place)' },
  { char: '旅游', pinyin: 'lǚyóu', meaning: 'travel' },
  { char: '散步', pinyin: 'sànbù', meaning: 'take a walk' },
  { char: '聊天', pinyin: 'liáotiān', meaning: 'chat' },
  { char: '讨论', pinyin: 'tǎolùn', meaning: 'discuss' },
  { char: '商量', pinyin: 'shāngliang', meaning: 'consult' },
  { char: '解释', pinyin: 'jiěshì', meaning: 'explain' },
  { char: '说明', pinyin: 'shuōmíng', meaning: 'illustrate' },
  { char: '证明', pinyin: 'zhèngmíng', meaning: 'prove' },
  { char: '建议', pinyin: 'jiànyì', meaning: 'suggest' },
  { char: '批评', pinyin: 'pīpíng', meaning: 'criticize' },
  { char: '表扬', pinyin: 'biǎoyáng', meaning: 'praise' },
  { char: '鼓励', pinyin: 'gǔlì', meaning: 'encourage' },
  { char: '保证', pinyin: 'bǎozhèng', meaning: 'guarantee' },
  { char: '提醒', pinyin: 'tíxǐng', meaning: 'remind' },
  { char: '通知', pinyin: 'tōngzhī', meaning: 'notify' },
  { char: '广播', pinyin: 'guǎngbō', meaning: 'broadcast' },
  { char: '联系', pinyin: 'liánxì', meaning: 'contact' },
  { char: '调查', pinyin: 'diàochá', meaning: 'investigate' },
  { char: '检查', pinyin: 'jiǎnchá', meaning: 'inspect' },
  { char: '研究', pinyin: 'yánjiū', meaning: 'research' },
  { char: '了解', pinyin: 'liǎojiě', meaning: 'understand deeply' },
  { char: '熟悉', pinyin: 'shúxī', meaning: 'be familiar with' },
  { char: '适应', pinyin: 'shìyìng', meaning: 'adapt' },
  { char: '适合', pinyin: 'shìhé', meaning: 'suit' },
  { char: '符合', pinyin: 'fúhé', meaning: 'accord with' },
  { char: '满足', pinyin: 'mǎnzú', meaning: 'satisfy' },
  { char: '引起', pinyin: 'yǐnqǐ', meaning: 'cause' },
  { char: '造成', pinyin: 'zàochéng', meaning: 'result in' },
  { char: '增加', pinyin: 'zēngjiā', meaning: 'increase' },
  { char: '减少', pinyin: 'jiǎnshǎo', meaning: 'decrease' },
  { char: '降低', pinyin: 'jiàngdī', meaning: 'lower' },
  { char: '不仅', pinyin: 'bùjǐn', meaning: 'not only' },
  { char: '除了', pinyin: 'chúle', meaning: 'except' },
  { char: '按照', pinyin: 'ànzhào', meaning: 'according to' },
  { char: '通过', pinyin: 'tōngguò', meaning: 'pass through' },
  { char: '经过', pinyin: 'jīngguò', meaning: 'go through' },
  { char: '来自', pinyin: 'láizì', meaning: 'come from' },
  { char: '对于', pinyin: 'duìyú', meaning: 'with regard to' },
  { char: '关于', pinyin: 'guānyú', meaning: 'about' },
  { char: '互相', pinyin: 'hùxiāng', meaning: 'mutually' },
  { char: '共同', pinyin: 'gòngtóng', meaning: 'common' },
  { char: '到底', pinyin: 'dàodǐ', meaning: 'in the end' },
  { char: '究竟', pinyin: 'jiūjìng', meaning: 'after all' },
  { char: '原来', pinyin: 'yuánlái', meaning: 'originally' },
  { char: '本来', pinyin: 'běnlái', meaning: 'originally' },
  { char: '重新', pinyin: 'chóngxīn', meaning: 'again' },
  { char: '继续', pinyin: 'jìxù', meaning: 'continue' },
  { char: '坚持', pinyin: 'jiānchí', meaning: 'persist' },
  { char: '放弃', pinyin: 'fàngqì', meaning: 'give up' },
  { char: '反对', pinyin: 'fǎnduì', meaning: 'oppose' },
  { char: '支持', pinyin: 'zhīchí', meaning: 'support' },
  { char: '尊重', pinyin: 'zūnzhòng', meaning: 'respect' },
  { char: '原谅', pinyin: 'yuánliàng', meaning: 'forgive' },
  { char: '道歉', pinyin: 'dàoqiàn', meaning: 'apologize' },
  { char: '感谢', pinyin: 'gǎnxiè', meaning: 'thank' },
  { char: '邀请', pinyin: 'yāoqǐng', meaning: 'invite' },
  { char: '举办', pinyin: 'jǔbàn', meaning: 'hold (event)' },
  { char: '举行', pinyin: 'jǔxíng', meaning: 'hold (meeting)' },
  { char: '进行', pinyin: 'jìnxíng', meaning: 'carry out' },
  { char: '禁止', pinyin: 'jìnzhǐ', meaning: 'prohibit' },
  { char: '推迟', pinyin: 'tuīchí', meaning: 'postpone' },
  { char: '提前', pinyin: 'tíqián', meaning: 'advance' },
  { char: '浪费', pinyin: 'làngfèi', meaning: 'waste' },
  { char: '节约', pinyin: 'jiéyuē', meaning: 'save' },
  { char: '保护', pinyin: 'bǎohù', meaning: 'protect' },
  { char: '污染', pinyin: 'wūrǎn', meaning: 'pollute' },
  { char: '破坏', pinyin: 'pòhuài', meaning: 'destroy' },
  { char: '建设', pinyin: 'jiànshè', meaning: 'construct' },
  { char: '制造', pinyin: 'zhìzào', meaning: 'manufacture' },
  { char: '生产', pinyin: 'shēngchǎn', meaning: 'produce' },
  { char: '产生', pinyin: 'chǎnshēng', meaning: 'generate' },
  { char: '出现', pinyin: 'chūxiàn', meaning: 'appear' },
  { char: '消失', pinyin: 'xiāoshī', meaning: 'disappear' },
  { char: '存在', pinyin: 'cúnzài', meaning: 'exist' },
  { char: '代表', pinyin: 'dàibiǎo', meaning: 'represent' },
  { char: '代替', pinyin: 'dàitì', meaning: 'replace' },
  { char: '担任', pinyin: 'dānrèn', meaning: 'serve as' },
  { char: '负责', pinyin: 'fùzé', meaning: 'be responsible for' },
  { char: '包含', pinyin: 'bāohán', meaning: 'contain' },
  { char: '包括', pinyin: 'bāokuò', meaning: 'include' },
  { char: '缺少', pinyin: 'quēshǎo', meaning: 'lack' },
  { char: '充满', pinyin: 'chōngmǎn', meaning: 'be full of' },
  { char: '估计', pinyin: 'gūjì', meaning: 'estimate' },
  { char: '考虑', pinyin: 'kǎolǜ', meaning: 'consider' },
  { char: '商量', pinyin: 'shāngliang', meaning: 'discuss' },
  { char: '看法', pinyin: 'kànfǎ', meaning: 'viewpoint' },
  { char: '观点', pinyin: 'guāndiǎn', meaning: 'standpoint' },
  { char: '意见', pinyin: 'yìjiàn', meaning: 'opinion' },
  { char: '印象', pinyin: 'yìnxiàng', meaning: 'impression' },
  { char: '态度', pinyin: 'tàidu', meaning: 'attitude' },
  { char: '习惯', pinyin: 'xíguàn', meaning: 'habit' },
  { char: '经验', pinyin: 'jīngyàn', meaning: 'experience' },
  { char: '知识', pinyin: 'zhīshi', meaning: 'knowledge' },
  { char: '能力', pinyin: 'nénglì', meaning: 'capability' },
  { char: '技术', pinyin: 'jìshù', meaning: 'technology' },
  { char: '艺术', pinyin: 'yìshù', meaning: 'art' },
  { char: '数字', pinyin: 'shùzì', meaning: 'digit' },
  { char: '密码', pinyin: 'mìmǎ', meaning: 'password' },
  { char: '网站', pinyin: 'wǎngzhàn', meaning: 'website' },
  { char: '网络', pinyin: 'wǎngluò', meaning: 'network' },
  { char: '电子邮件', pinyin: 'diànzǐyóujiàn', meaning: 'email' },
  { char: '短信', pinyin: 'duǎnxìn', meaning: 'SMS' },
  { char: '恐怕', pinyin: 'kǒngpà', meaning: 'afraid that' },
  { char: '也许', pinyin: 'yěxǔ', meaning: 'perhaps' },
  { char: '大概', pinyin: 'dàgài', meaning: 'probably' },
  { char: '顺便', pinyin: 'shùnbiàn', meaning: 'conveniently' },
  { char: '随便', pinyin: 'suíbiàn', meaning: 'casual' },
  { char: '到底', pinyin: 'dàodǐ', meaning: 'on earth' },
  { char: '竟然', pinyin: 'jìngrán', meaning: 'unexpectedly' },
  { char: '果然', pinyin: 'guǒrán', meaning: 'as expected' },
  { char: '专门', pinyin: 'zhuānmén', meaning: 'specifically' },
  { char: '尤其', pinyin: 'yóuqí', meaning: 'especially' },
  { char: '甚至', pinyin: 'shènzhì', meaning: 'even' },
  { char: '一直', pinyin: 'yīzhí', meaning: 'always' },
  { char: '总是', pinyin: 'zǒngshì', meaning: 'always' },
  { char: '经常', pinyin: 'jīngcháng', meaning: 'often' },
  { char: '平时', pinyin: 'píngshí', meaning: 'usually' },
  { char: '偶尔', pinyin: 'ǒuěr', meaning: 'occasionally' },
  { char: '从来', pinyin: 'cónglái', meaning: 'always/never' },
  { char: '刚刚', pinyin: 'gānggāng', meaning: 'just now' },
  { char: '刚才', pinyin: 'gāngcái', meaning: 'just now' },
  { char: '已经', pinyin: 'yǐjīng', meaning: 'already' },
  { char: '曾经', pinyin: 'céngjīng', meaning: 'once' },
  { char: '正在', pinyin: 'zhèngzài', meaning: 'in process of' },
  { char: '将要', pinyin: 'jiāngyào', meaning: 'going to' },
  { char: '马上', pinyin: 'mǎshàng', meaning: 'immediately' },
  { char: '立刻', pinyin: 'lìkè', meaning: 'at once' },
  { char: '逐渐', pinyin: 'zhújiàn', meaning: 'gradually' },
  { char: '终于', pinyin: 'zhōngyú', meaning: 'finally' },
  { char: '至少', pinyin: 'zhìshǎo', meaning: 'at least' },
  { char: '最好', pinyin: 'zuìhǎo', meaning: 'had better' },
  { char: '大约', pinyin: 'dàyuē', meaning: 'approximately' },
  { char: '左右', pinyin: 'zuǒyòu', meaning: 'around' },
  { char: '全部', pinyin: 'quánbù', meaning: 'all' },
  { char: '所有', pinyin: 'suǒyǒu', meaning: 'all' },
  { char: '整个', pinyin: 'zhěnggè', meaning: 'whole' },
  { char: '大部分', pinyin: 'dàbùfen', meaning: 'majority' },
  { char: '一部分', pinyin: 'yībùfen', meaning: 'part' },
  { char: '许多', pinyin: 'xǔduō', meaning: 'many' },
  { char: '到处', pinyin: 'dàochù', meaning: 'everywhere' },
  { char: '互相', pinyin: 'hùxiāng', meaning: 'each other' },

  { char: '大小', pinyin: 'dàxiǎo', meaning: 'size (big-small)' },
  { char: '多少', pinyin: 'duōshao', meaning: 'how many/much' },
  { char: '长短', pinyin: 'chángduǎn', meaning: 'length' },
  { char: '高低', pinyin: 'gāodī', meaning: 'height/level' },
  { char: '轻重', pinyin: 'qīngzhòng', meaning: 'weight' },
  { char: '东西', pinyin: 'dōngxi', meaning: 'east and west / things' },
  { char: '南北', pinyin: 'nánběi', meaning: 'north and south' },
  { char: '左右', pinyin: 'zuǒyòu', meaning: 'around/control' },
  { char: '前后', pinyin: 'qiánhòu', meaning: 'front and back' },
  { char: '里外', pinyin: 'lǐwài', meaning: 'inside and outside' },
  { char: '上下', pinyin: 'shàngxià', meaning: 'up and down' },
  { char: '开关', pinyin: 'kāiguān', meaning: 'switch (open-close)' },
  { char: '买卖', pinyin: 'mǎimài', meaning: 'trade/business' },
  { char: '来往', pinyin: 'láiwǎng', meaning: 'come and go / dealings' },
  { char: '进出', pinyin: 'jìnchū', meaning: 'entry and exit' },
  { char: '好坏', pinyin: 'hǎohuài', meaning: 'quality (good-bad)' },
  { char: '生死', pinyin: 'shēngsǐ', meaning: 'life and death' },
  { char: '男女', pinyin: 'nánnǚ', meaning: 'men and women' },
  { char: '老少', pinyin: 'lǎoshào', meaning: 'old and young' },
  { char: '黑白', pinyin: 'hēibái', meaning: 'black and white' },

  { char: '人口', pinyin: 'rénkǒu', meaning: 'population' },
  { char: '人心', pinyin: 'rénxīn', meaning: 'popular feeling' },
  { char: '手足', pinyin: 'shǒuzú', meaning: 'brothers (hand and foot)' },
  { char: '心跳', pinyin: 'xīntiào', meaning: 'heartbeat' },
  { char: '眼光', pinyin: 'yǎnguāng', meaning: 'vision/insight' },
  { char: '目光', pinyin: 'mùguāng', meaning: 'gaze/sight' },
  { char: '口气', pinyin: 'kǒuqì', meaning: 'tone of voice' },
  { char: '口味', pinyin: 'kǒuwèi', meaning: 'taste/dietary preference' }, // 味 is usually top 1000
  { char: '体力', pinyin: 'tǐlì', meaning: 'physical strength' },
  { char: '心意', pinyin: 'xīnyì', meaning: 'regard/kindly feelings' },

  { char: '上车', pinyin: 'shàngchē', meaning: 'get on (vehicle)' },
  { char: '下车', pinyin: 'xiàchē', meaning: 'get off (vehicle)' },
  { char: '上课', pinyin: 'shàngkè', meaning: 'attend class' }, // 课 is usually top 1000
  { char: '下课', pinyin: 'xiàkè', meaning: 'finish class' },
  { char: '上班', pinyin: 'shàngbān', meaning: 'go to work' },
  { char: '下班', pinyin: 'xiàbān', meaning: 'get off work' },
  { char: '上楼', pinyin: 'shànglóu', meaning: 'go upstairs' }, // 楼 is usually top 1000
  { char: '下楼', pinyin: 'xiàlóu', meaning: 'go downstairs' },
  { char: '上山', pinyin: 'shàngshān', meaning: 'go up the mountain' },
  { char: '下山', pinyin: 'xiàshān', meaning: 'go down the mountain' },
  { char: '出口', pinyin: 'chūkǒu', meaning: 'exit' },
  { char: '入口', pinyin: 'rùkǒu', meaning: 'entrance' },
  { char: '出门', pinyin: 'chūmén', meaning: 'go out' },
  { char: '进门', pinyin: 'jìnmén', meaning: 'enter door' },
  { char: '回家', pinyin: 'huíjiā', meaning: 'return home' },
  { char: '回国', pinyin: 'huíguó', meaning: 'return to one\'s country' },
  { char: '回头', pinyin: 'huítóu', meaning: 'turn head / later' },
  { char: '带头', pinyin: 'dàitóu', meaning: 'take the lead' },
  { char: '握手', pinyin: 'wòshǒu', meaning: 'shake hands' }, // 握 is usually top 1000
  { char: '招手', pinyin: 'zhāoshǒu', meaning: 'wave hand' }, // 招 is usually top 1000
  { char: '放手', pinyin: 'fàngshǒu', meaning: 'let go' },
  { char: '住手', pinyin: 'zhùshǒu', meaning: 'stop (doing sth)' },
  { char: '动手', pinyin: 'dòngshǒu', meaning: 'hit / start work' },
  { char: '动身', pinyin: 'dòngshēn', meaning: 'set out (on a journey)' },
  { char: '动心', pinyin: 'dòngxīn', meaning: 'be tempted' },

  { char: '风雨', pinyin: 'fēngyǔ', meaning: 'wind and rain / hardships' },
  { char: '山水', pinyin: 'shānshuǐ', meaning: 'landscape / scenery' },
  { char: '江河', pinyin: 'jiānghé', meaning: 'rivers' },
  { char: '水电', pinyin: 'shuǐdiàn', meaning: 'water and electricity' },
  { char: '火力', pinyin: 'huǒlì', meaning: 'firepower' },
  { char: '风力', pinyin: 'fēnglì', meaning: 'wind power' },
  { char: '水利', pinyin: 'shuǐlì', meaning: 'water conservancy' },
  { char: '天亮', pinyin: 'tiānliàng', meaning: 'daybreak' },
  { char: '天黑', pinyin: 'tiānhēi', meaning: 'getting dark' },
  { char: '星光', pinyin: 'xīngguāng', meaning: 'starlight' },
  { char: '月光', pinyin: 'yuèguāng', meaning: 'moonlight' },
  { char: '阳光', pinyin: 'yángguāng', meaning: 'sunlight' },
  { char: '土地', pinyin: 'tǔdì', meaning: 'land/soil' },

  { char: '有人', pinyin: 'yǒurén', meaning: 'someone / there is someone' },
  { char: '无人', pinyin: 'wúrén', meaning: 'unmanned' },
  { char: '有力', pinyin: 'yǒulì', meaning: 'powerful' },
  { char: '无力', pinyin: 'wúlì', meaning: 'powerless' },
  { char: '公用', pinyin: 'gōngyòng', meaning: 'public use' },
  { char: '私有', pinyin: 'sīyǒu', meaning: 'private' }, // 私 is usually top 1000
  { char: '自学', pinyin: 'zìxué', meaning: 'self-study' },
  { char: '自用', pinyin: 'zìyòng', meaning: 'for personal use' },
  { char: '自由', pinyin: 'zìyóu', meaning: 'freedom' },
  { char: '自然', pinyin: 'zìrán', meaning: 'nature / natural' },
  { char: '自信', pinyin: 'zìxìn', meaning: 'self-confidence' },
  { char: '主要', pinyin: 'zhǔyào', meaning: 'main/major' },
  { char: '次要', pinyin: 'cìyào', meaning: 'secondary/minor' },
  { char: '合法', pinyin: 'héfǎ', meaning: 'legal' },
  { char: '非法', pinyin: 'fēifǎ', meaning: 'illegal' },
  { char: '正式', pinyin: 'zhèngshì', meaning: 'formal' },
  { char: '公开', pinyin: 'gōngkāi', meaning: 'public/open' },
  { char: '公平', pinyin: 'gōngpíng', meaning: 'fair' },
  { char: '和平', pinyin: 'hépíng', meaning: 'peace' },
  { char: '平民', pinyin: 'píngmín', meaning: 'common people' },
  { char: '公民', pinyin: 'gōngmín', meaning: 'citizen' },
  { char: '市民', pinyin: 'shìmín', meaning: 'city resident' },
  { char: '村民', pinyin: 'cūnmín', meaning: 'villager' }, // 村 is usually top 1000
  { char: '农民', pinyin: 'nóngmín', meaning: 'farmer' },

  { char: '日常', pinyin: 'rìcháng', meaning: 'daily' },
  { char: '平日', pinyin: 'píngrì', meaning: 'weekdays/ordinarily' },
  { char: '节日', pinyin: 'jiérì', meaning: 'holiday' },
  { char: '生日', pinyin: 'shēngrì', meaning: 'birthday' },
  { char: '日子', pinyin: 'rìzi', meaning: 'day/life' },
  { char: '日期', pinyin: 'rìqī', meaning: 'date' },
  { char: '学期', pinyin: 'xuéqī', meaning: 'semester' },
  { char: '假期', pinyin: 'jiàqī', meaning: 'vacation' }, // 假 is usually top 1000
  { char: '按时', pinyin: 'ànshí', meaning: 'on time' },
  { char: '准时', pinyin: 'zhǔnshí', meaning: 'punctual' },
  { char: '暂时', pinyin: 'zànshí', meaning: 'temporary' }, // 暂 is usually top 1000
  { char: '及时', pinyin: 'jíshí', meaning: 'timely' },
  { char: '长久', pinyin: 'chángjiǔ', meaning: 'long-lasting' },
  { char: '永久', pinyin: 'yǒngjiǔ', meaning: 'permanent' },
  { char: '古老', pinyin: 'gǔlǎo', meaning: 'ancient' },
  { char: '当代', pinyin: 'dāngdài', meaning: 'contemporary' },
  { char: '近代', pinyin: 'jìndài', meaning: 'modern times' },
  { char: '年代', pinyin: 'niándài', meaning: 'decade/era' },
  { char: '世纪', pinyin: 'shìjì', meaning: 'century' },
  { char: '万岁', pinyin: 'wànsuì', meaning: 'long live' },
];
